<script>
    import Auth from  './Auth';

    export default {
        name: "ActionAccess",
        mixins:{Auth},
        methods: {
            authActionHandle(data) {
                if(!this.isUserLoggedIn) {
                    this.authFailActionHandle(data);
                } else {
                    this.authSuccessActionHandle(data);
                }

            },
            authFailActionHandle(data) {
                switch(data.type) {
                    case 'cart': this.noLoginAction(data); break;
                    default: this.$store.commit('loginDialogShow');
                }
            },
            authSuccessActionHandle(data) {
                /* override for success handle action */
            },
            noLoginAction(data) {
                /* override for success handle action */
            }
        }
    }
</script>

<style scoped>

</style>
